<section class="support-bar-section">
  <div class="container">
    <div class="support-bar-wrapper">

      <div class="support-item">
        <div class="support-icon">
          <i class="fa-solid fa-comments"></i>
        </div>
        <div class="support-text">
          <span class="support-title">Email support</span>
           <a href="mailto:data.analyst-31&#64;indiaai.gov.in" class="support-email">
            data.analyst-31&#64;indiaai.gov.in
          </a>
        </div>
      </div>

    </div>
  </div>
</section>